<template>
  <div class="determine">
    <!-- ---头部--- -->
    <content-title title="数据的确定方式" />
    <!-- ---说明--- -->
    <write-instruction>
      <div>
        <p>
          1、数据计算方法及获取方式中，若选择实测值，请在具体描述中写明具体方法和标准；若选择默认值，请在具体描述中填写具体数值；若选择相关方结算凭证，请在具体描述中填写如何确保供应商数据质量；若选择其他方式，请在具体描述中填写详细描述。</p>
        <p>2、需要填报机组信息表中全部机组相关参数的数据的确定方式，若需要对机组进行调整（比如新增、合并或拆分），请在机组信息表中进行操作。</p>
        <p>3、如果报告数据是由若干个参数通过一定的计算方法计算得出，需要填写计算公式以及计算公式中的每一个参数的获取方式。</p>
      </div>
    </write-instruction>
    <!-- ---新增按钮--- -->
    <div class="add-btn" v-if="editOrView == 'edit'">
      <Button type="primary" style="background-color: #009FD9;border-color: #009FD9" @click="addProduction">
        同步填报
      </Button>
    </div>
    <!-- ---内容--- -->
    <Table @on-row-click="rowClick" :disabled-hover="true" :span-method="SpanCellMerge" border :columns="columns" :data="newData" :height="windowHeight" :loading="tableLoading">
      <template slot="introduction" slot-scope="{row}">
        <div :class="{'self-disabled':row.methodType==='/'|| keyForAct.introduction.disabled.indexOf(row.paramName )!==-1}">{{row.introduction}}</div>
      </template>
      <template slot="unitCode" slot-scope="{row}">
        <div :class="{'self-disabled': keyForAct.unitCode.disabled.indexOf(row.methodType )!==-1}">{{row.unitCode}}</div>
      </template>
      <template slot="unitInstallAddr" slot-scope="{row}">
        <div :class="{'self-disabled': keyForAct.unitInstallAddr.disabled.indexOf(row.methodType )!==-1}">{{row.unitInstallAddr}}</div>
      </template>
      <template slot="monitorRate" slot-scope="{row}">
        <div :class="{'self-disabled': keyForAct.monitorRate.disabled.indexOf(row.methodType )!==-1}">{{row.monitorRate}}</div>
      </template>
      <template slot="unitAccuracy" slot-scope="{row}">
        <div :class="{'self-disabled': keyForAct.unitAccuracy.disabled.indexOf(row.methodType )!==-1}">{{row.unitAccuracy}}</div>
      </template>
      <template slot="givenMonitorRate" slot-scope="{row}">
        <div :class="{'self-disabled': keyForAct.givenMonitorRate.disabled.indexOf(row.methodType )!==-1}">{{row.givenMonitorRate}}</div>
      </template>
      <template slot="dataRecordRate" slot-scope="{row}">
        <div :class="{'self-disabled': keyForAct.dataRecordRate.disabled.indexOf(row.methodType )!==-1}">{{row.dataRecordRate}}</div>
      </template>
      <template slot="missDataMethod" slot-scope="{row}">
        <div :class="{'self-disabled': keyForAct.missDataMethod.disabled.indexOf(row.methodType )!==-1}">{{row.missDataMethod}}</div>
      </template>
      <template slot="getDataDepartment" slot-scope="{row}">
        <div :class="{'self-disabled': keyForAct.getDataDepartment.disabled.indexOf(row.methodType )!==-1}">{{row.getDataDepartment}}</div>
      </template>
    </Table>
    <!-- ---底部按钮组--- -->
    <save-next v-if="editOrView == 'edit'" :btnLoading="btnLoading" @on-save="handleSave('save')" @go-next="goNext" />
    <!-- ---同步填报--- -->
    <Modal v-model="addModal" @on-visible-change="modalChange">
      <div slot="header">
        <span style="fontWeight: bold">同步填报</span>
      </div>
      <Form ref="modalForm" :label-width="100" :model="modalForm" :rules="addRules">
        <div class="model-instructions">
          <div class="model-instructions indentation-2">说明：对于企业存在多个机组中参数的确定方式、监测设备相同的情况，可以将已填报的信息复制到多个机组的数据确定方式中。</div>
          <div class="model-instructions indentation-2">请选择已经填报完成的源机组：</div>
          <FormItem label="源机组:" style="width: 400px" prop="sourceUnitName">
            <Select v-model="modalForm.sourceUnitName" @on-change="sourceUnitNameChange">
              <Option v-for="item in unitNameOptions" :key="item" :value="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <div class="model-instructions indentation-2">请选择需要复制源机组信息的目标机组：</div>
          <FormItem label="目标机组:" style="width:400px" prop="targetsUnitName">
            <Select v-model="modalForm.targetsUnitName" multiple>
              <Option v-for="item in otherOptions" :key="item" :value="item">{{ item }}</Option>
            </Select>
          </FormItem>
        </div>

      </Form>
      <div slot="footer">
        <Button type="text" @click="modalCancel">取消</Button>
        <Button type="primary" style="background-color: #009FD9;border-color: #009FD9" @click="addConfirm" :loading="addBtnLoading">
          确定
        </Button>
      </div>
    </Modal>
    <Modal v-model="editModal" @on-visible-change="editModalChange" width='1000px'>
      <div slot="header">
        <span style="font-weight:bold;font-size:16px">编辑数据</span>
      </div>
      <Scroll height="400">
        <Form ref="editForm" :model="editForm" :rules="editRoles" :label-width="170">
          <FormItem label="机组名称:" class="edit-item">
            <Input v-model="editForm.unitName" disabled />
          </FormItem>
          <FormItem label="参数名称:" class="edit-item">
            <Input v-model="editForm.paramName" disabled />
          </FormItem>
          <FormItem label="单位:" class="edit-item">
            <Select v-if="editForm.paramName==='供电煤（气）耗'" v-model="editForm.unit">
              <Option v-for="item in unitOptions1" :key="item" :value="item">{{ item }}</Option>
            </Select>
            <Select v-else-if="editForm.paramName==='供热煤（气）耗'" v-model="editForm.unit">
              <Option v-for="item in unitOptions2" :key="item" :value="item">{{ item }}</Option>
            </Select>
            <Input v-else v-model="editForm.unit" disabled />
          </FormItem>
          <Divider>数据的计算方法及其获取方式</Divider>
          <FormItem label="方式类型:" class="edit-item" prop="methodType">
            <Select v-model="editForm.methodType" @on-change="methodTypeChange" v-if="keyForAct.methodType.show2.indexOf(editForm.paramName)!==-1">
              <Option v-for="item in methodOptions2" :key="item" :value="item">{{item}}</Option>
            </Select>
            <Select v-model="editForm.methodType" @on-change="methodTypeChange" v-else-if="editForm.paramName!=='燃油碳氧化率' && editForm.paramName!=='燃气碳氧化率' && editForm.paramName!=='燃煤碳氧化率' && editForm.paramName!=='电网排放因子'&&  editForm.paramName!=='二氧化碳排放量' && editForm.paramName!=='购入电力排放量' && editForm.paramName!=='全部机组二氧化碳排放总量'">
              <Option v-for="item in methodOptions" :key="item" :value="item">{{item}}</Option>
            </Select>
            <Input v-model="editForm.methodType" v-else disabled />
          </FormItem>
          <FormItem label="具体描述:" class="edit-item">
            <Input type="textarea" v-model="editForm.introduction" :disabled="editForm.methodType==='/'|| keyForAct.introduction.disabled.indexOf(editForm.paramName )!==-1" />
          </FormItem>
          <Divider>测量设备（适用于数据获取方式来源于实测值）</Divider>
          <FormItem label="监测设备及型号:" class="edit-item">
            <Input v-model="editForm.unitCode" :disabled="keyForAct.unitCode.disabled.indexOf(editForm.methodType )!==-1" />
          </FormItem>
          <FormItem label="监测设备安装位置:" class="edit-item">
            <Input v-model="editForm.unitInstallAddr" :disabled="keyForAct.unitInstallAddr.disabled.indexOf(editForm.methodType )!==-1" />
          </FormItem>
          <FormItem label="监测频次:" class="edit-item">
            <Select v-model="editForm.monitorRate" :disabled="keyForAct.monitorRate.disabled.indexOf(editForm.methodType )!==-1">
              <Option v-for="item in frequencyOptions" :key="item" :value="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem label="监测设备精度:" class="edit-item">
            <Input v-model="editForm.unitAccuracy" :disabled="keyForAct.unitAccuracy.disabled.indexOf(editForm.methodType )!==-1" />
          </FormItem>
          <FormItem label="规定的监测设备校准频次:" class="edit-item">
            <Select v-model="editForm.givenMonitorRate" :disabled="keyForAct.givenMonitorRate.disabled.indexOf(editForm.methodType )!==-1">
              <Option v-for="item in frequencyOptions" :key="item" :value="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <Divider />
          <FormItem label="数据记录频次:" class="edit-item">
            <Select v-model="editForm.dataRecordRate" :disabled="keyForAct.dataRecordRate.disabled.indexOf(editForm.methodType )!==-1">
              <Option v-for="item in frequencyOptions" :key="item" :value="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem label="数据缺失时的处理方式:" class="edit-item">
            <Input v-model="editForm.missDataMethod" :disabled="keyForAct.missDataMethod.disabled.indexOf(editForm.methodType )!==-1" />
          </FormItem>
          <FormItem label="数据获取负责部门:" class="edit-item">
            <Input v-model="editForm.getDataDepartment" :disabled="keyForAct.getDataDepartment.disabled.indexOf(editForm.methodType )!==-1" />
          </FormItem>
        </Form>
      </Scroll>
      <div slot="footer">
        <Button type="text" @click="editModal=false">取消</Button>
        <Button type="primary" style="background-color: #009FD9;border-color: #009FD9" @click="editModalOk" :loading="editLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import contentTitle from "@/components/comment/content-title.vue";
import writeInstruction from "@/components/comment/write-instruction.vue";
import saveNext from "@/components/comment/save-next.vue";

import { confirmMethodDetail, confirmMethodSave, dataConfirmSyncFilling } from "@/api/monitoring-plan";


export default {
  components: {
    contentTitle,
    writeInstruction,
    saveNext,
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    planId () {
      return this.getUserInfo.user.planId;
    },
    companyId () {
      return this.getUserInfo.user.companyId;
    },
    permitCode () {
      return this.getUserInfo.user.permitCode;
    },
    windowHeight () {
      return window.innerHeight - 80;
    },
    editOrView () {
      return this.getUserInfo.user.editOrView;
    },
  },
  data () {
    return {
      btnLoading: {
        saveUnit: false,
        nextPage: false
      },
      editForm: {},
      editDataIndex: '', // 当前正在编辑数据的index
      editModal: false,
      editLoading: false,

      merge1: [], // 合并行
      pos1: 0, // 合并列

      tableLoading: true,

      addBtnLoading: false,
      addModal: false,

      modalForm: {
        sourceUnitName: "",
        targetsUnitName: [],
      },
      addRules: {
        sourceUnitName: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        targetsUnitName: [
          {
            required: true,
            type: "array",
            message: "不能为空",
            trigger: "change",
          },
        ],
      },

      editRoles: {
        methodType: [
          { required: true, message: "不能为空", trigger: "change" },
        ]
      },
      keyForAct: {
        methodType: {
          // 选项中含有  '/'
          show2: ['供热量', '供热比', '供热煤耗', '供热碳排放强度'],
          // 选项中不含  '/'
          show: ['燃油碳氧化率', '燃气碳氧化率', '燃煤碳氧化率', '电网排放因子', '二氧化碳排放量', '购入电力排放量', '全部机组二氧化碳排放总量']
        },
        introduction: {
          disabled: ['/', '燃油碳氧化率', '燃气碳氧化率', '燃煤碳氧化率', '电网排放因子', '二氧化碳排放量', '购入电力排放量', '全部机组二氧化碳排放总量']
        },
        unitCode: {
          disabled: ['/', '缺省值', '碳氧化率']
        },
        unitInstallAddr: {
          disabled: ['/', '缺省值', '碳氧化率']
        },
        monitorRate: {
          disabled: ['/', '缺省值', '碳氧化率']
        },
        unitAccuracy: {
          disabled: ['/', '缺省值', '碳氧化率']
        },
        givenMonitorRate: {
          disabled: ['/', '缺省值', '碳氧化率']
        },
        dataRecordRate: {
          disabled: ['/', '缺省值', '碳氧化率']
        },
        missDataMethod: {
          disabled: ['/', '缺省值', '碳氧化率']
        },
        getDataDepartment: {
          disabled: ['/', '缺省值', '碳氧化率']
        },
      },
      unitNameOptions: [], // 机组名称列表
      otherOptions: [], // 同步填报的机组
      // 方式类型
      methodOptions: ["实测值", "缺省值", "计算值", "其他"],
      methodOptions2: ["实测值", "缺省值", "计算值", "其他", '/'],
      // 规定的监测设备校准频次
      frequencyOptions: [
        "/",
        "每小时",
        "每天",
        "每周",
        "每旬",
        "每半月",
        "每月",
        "每季度",
        "每半年",
        "每年",
        "每两年",
        "每三年",
        "每五年及以上",
        "连续",
        "每班次",
        "每批次",
      ],
      // 单位
      unitOptions1: ["tce/MWh", "10⁴Nm³/MWh"],
      unitOptions2: ["tce/GJ", "10⁴Nm³/GJ"],
      columns: [
        {
          title: "机组名称",
          align: "center",
          fixed: "left",
          key: "unitName",
          width: 100,
        },
        {
          title: "参数名称",
          align: "center",
          fixed: "left",
          key: "paramName",
          width: 180,
        },
        { title: "单位", align: "center", key: "unit", width: 120 },
        {
          title: "数据的计算方法及其获取方式",
          align: "center",
          children: [
            {
              title: "方式类型",
              align: "center",
              key: "methodType",
              width: 120,
            },
            {
              title: "具体描述",
              align: "center",
              slot: "introduction",
              width: 180,
            },
          ],
        },
        {
          title: "测量设备（适用于数据获取方式来源于实测值）",
          align: "center",
          children: [
            {
              title: "监测设备及型号",
              align: "center",
              slot: "unitCode",
              width: 180,
            },
            {
              title: "监测设备安装位置",
              align: "center",
              slot: "unitInstallAddr",
              width: 180,
            },
            {
              title: "监测频次",
              align: "center",
              slot: "monitorRate",
              width: 140,
            },
            {
              title: "监测设备精度",
              align: "center",
              slot: "unitAccuracy",
              width: 180,
            },
            {
              title: "规定的监测设备校准频次",
              align: "center",
              slot: "givenMonitorRate",
              width: 140,
            },
          ],
        },
        {
          title: "数据记录频次",
          align: "center",
          slot: "dataRecordRate",
          width: 140,
        },
        {
          title: "数据缺失时的处理方式",
          align: "center",
          slot: "missDataMethod",
          width: 180,
        },
        {
          title: "数据获取负责部门",
          align: "center",
          slot: "getDataDepartment",
          width: 180,
        },
      ],
      data: [],
      newData: [],
    };
  },
  created () {
    this.getList();
  },
  methods: {
    async getList () {
      let params = {
        planId: this.planId,
        companyId: this.companyId,
      };
      this.tableLoading = true;
      await confirmMethodDetail(params).then((res) => {
        if (res.message == "success") {
          this.data = res.body.cmlist;
          this.unitNameOptions = res.body.unitNameList;
          let tempData = [];
          // 处理数据用于表格合并判断
          for (let i = 0; i < this.data.length; i++) {
            if (this.data[i].paramName === "全部机组二氧化碳排放总量") {
              this.data[i].unitName = this.data[i].paramName;
              tempData.push(this.data[i]);
              this.data.splice(i, 1);
              break;
            }
          }
          this.data = [...this.data, ...tempData];
          this.getSpanArr(this.data, "unitName");
          this.newData = JSON.parse(JSON.stringify(this.data));
          this.tableLoading = false;
        }
      });
    },
    methodTypeChange (data) {
      if (this.editForm.methodType === '/' || this.editForm.methodType === '缺省值') {
        this.editForm.unitCode = "";
        this.editForm.unitInstallAddr = "";
        this.editForm.monitorRate = "";
        this.editForm.unitAccuracy = "";
        this.editForm.givenMonitorRate = "";
        this.editForm.dataRecordRate = "";
        this.editForm.missDataMethod = "";
        this.editForm.getDataDepartment = "";
      }
      if (this.editForm.methodType === '/') {
        this.editForm.introduction = "";
      }
    },
    // 合并列表
    getSpanArr (data, key1, key2) {
      let num = 0;
      if (key2 == undefined) {
        num = 1;
      } else {
        num = 2;
      }
      this[`merge${num}`] = [];
      this[`pos${num}`] = "";
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this[`merge${num}`].push(1);
          this[`pos${num}`] = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          //根据相同key进行合并,根据需要可进行修改
          let temp;
          if (key2 != undefined) {
            temp =
              data[i][key2] === data[i - 1][key2] &&
              data[i][key1] === data[i - 1][key1];
          }
          if (key2 == undefined) {
            temp = data[i][key1] === data[i - 1][key1];
          }
          if (temp) {
            this[`merge${num}`][this[`pos${num}`]] += 1;
            this[`merge${num}`].push(0);
          } else {
            this[`merge${num}`].push(1);
            this[`pos${num}`] = i;
          }
        }
      }
    },
    SpanCellMerge ({ row, column, rowIndex, columnIndex }) {
      const _row = this.merge1[rowIndex];
      const _col = _row > 0 ? 1 : 0;
      if (columnIndex === 0) {
        if (row.unitName == "全部机组二氧化碳排放总量") {
          return {
            rowspan: _row,
            colspan: 2,
          };
        } else {
          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      } else if (columnIndex === 1) {
        if (row.paramName == "全部机组二氧化碳排放总量") {
          return {
            rowspan: 0,
            colspan: -1,
          };
        }
      }
    },
    // 点击行
    rowClick (data, index) {
      this.$refs.editForm.resetFields();
      if (this.editOrView !== 'edit') {
        return
      }

      this.editModal = true
      this.editForm = Object.assign({}, data)
      this.editDataIndex = index
    },
    editModalChange (value) {
      if (value) {

        this.editLoading = false
      }
    },
    editModalOk () {
      this.$refs.editForm.validate(valid => {
        this.editLoading = true
        if (valid) {
          this.newData.splice(this.editDataIndex, 1, Object.assign({}, this.editForm))
          this.editModal = false;
        } else {
          this.editLoading = false
        }
      })
    },

    // 打开同步填报modal
    async addProduction () {
      this.addModal = true;
    },
    modalCancel () {
      this.addModal = false;
    },
    // 原机组变化时
    sourceUnitNameChange (value) {
      this.modalForm.targetsUnitName = "";
      this.otherOptions = [];
      let temp = [];
      this.unitNameOptions.forEach((item) => {
        if (value !== item) {
          temp.push(item);
        }
      });
      this.otherOptions = temp;
    },
    // 重置表单
    modalChange (value) {
      if (value) {
        this.$refs.modalForm.resetFields();
      }
    },


    addConfirm () {
      this.$refs.modalForm.validate(async (valid) => {
        if (valid) {
          this.addBtnLoading = true;
          let params = {
            planId: this.planId,
            sourceUnitName: this.modalForm.sourceUnitName,
            targetsUnitName: this.modalForm.targetsUnitName.join(","),
          };
          await this.handleSave('asyncData');
          await dataConfirmSyncFilling(params).then((res) => {
            if (res.status === 200) {
              this.$Message.success("同步填报成功");
            }
          });
          this.addBtnLoading = false;
          this.addModal = false;
          await this.getList();
        } else {
          this.addBtnLoading = false;
        }
      });
    },
    async handleSave (type) {
      await this.save(type);
    },
    async save (type) {
      if (type === 'save') {
        this.btnLoading.saveUnit = true
      } else if (type === 'next') {
        this.btnLoading.nextPage = true
      }
      let listData = JSON.parse(JSON.stringify(this.newData));
      if (listData[listData.length - 1] == "全部机组二氧化碳排放总量") {
        listData[listData.length - 1].unitName = "";
      }
      let params = {
        planId: this.planId,
        listData: listData,
        companyId: this.companyId,
      };
      await confirmMethodSave(params).then(async res => {
        if (type === 'save') {
          await this.getList();
          this.$Message.success("保存成功");
          this.btnLoading.saveUnit = false
        } else if (type === 'next') {
          this.btnLoading.nextPage = false
        } else if (type === 'asyncData') {
          await this.getList();
        }
      })
    },
    async goNext () {
      let canLeave = 0;
      for (let i = 0; i < this.newData.length; i++) {
        if (this.newData[i].methodType === "") {
          this.$Message.error(
            this.newData[i].unitName +
            this.newData[i].paramName +
            "方式类型" +
            "未填写"
          );
          canLeave++;
          return;
        }
      }
      if (canLeave === 0) {
        await this.handleSave('next');
        this.$router.push({ path: "/plan/plan-8" });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.model-instructions {
  margin: auto;
  margin-bottom: 10px;
}
.edit-item {
  width: 400px;
  display: inline-block;
}
.self-disabled {
  margin: 5px 0 5px;
  width: 100%;
  min-height: 44px;
  background-color: rgba(202, 201, 201, 0.3);
}
</style>